import * as React from 'react';
import type { SVGProps } from 'react';
const SvgTime = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="#A5A5AA"
      fillRule="evenodd"
      d="M7 4.517A9 9 0 0 1 12 3a9.01 9.01 0 0 1 9 9A9 9 0 1 1 7 4.517Zm.909 13.606A7.363 7.363 0 0 0 12 19.363 7.372 7.372 0 0 0 19.364 12a7.363 7.363 0 1 0-11.455 6.123ZM12.818 7.09v4.57l2.215 2.215a.818.818 0 0 1-1.157 1.157l-2.455-2.454a.819.819 0 0 1-.24-.579V7.09a.818.818 0 1 1 1.637 0Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgTime;
